import React from "react";
import { AnimatePresence } from "framer-motion";
import Navbar from "./Navbar";
import ResedentialFacilities from "./Residential_Facilities/Residential_Facilities";
import Footer from "./Footer";
import './Css/Homepage.css'

function Resident() {
  return (
    <AnimatePresence>
      <Navbar />
      <ResedentialFacilities />
      <Footer />
    </AnimatePresence>
  );
}

export default Resident;